<h1 class="text-center" [innerHTML]="'moderat.wpcheck.start.headline' | translate"></h1>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-offset-1 medium-3 large-offset-2 large-3">
    <app-advisor-image path="/moc/verbrauchsanalyse-start.svg" [altText]="'moderat.verbrauchsanalyse.start.alt_text' | translate"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-7 large-5">
    <p [innerHTML]="'moderat.wpcheck.start.teaser' | translate"></p>
    <div class="callout lighter-gray show-for-large" [innerHTML]="'moderat.wpcheck.start.callout2' | translate"></div>
  </div>
  <div class="cell small-12 medium-offset-1 medium-10 large-offset-2 large-8 ">
    <div class="callout lighter-gray hide-for-large" [innerHTML]="'moderat.wpcheck.start.callout2' | translate"></div>
    <div class="callout secondary" [innerHTML]="'moderat.wpcheck.start.callout1' | translate"></div>
    <app-step-buttons [previousLink]="null" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextSubmit]="false" mediumWidthRight="auto" mediumOffset="0" largeOffset="0" largeWidthRight="auto" nextText="moderat.wpcheck.start.next"></app-step-buttons>
  </div>
</div>
